import React, { useCallback } from 'react';

import classNames from 'classnames';
import { LazyImage } from "components/Image/Index";
import * as fromProjects from 'store/Projects';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

import { ParallaxTile } from './ParallaxTile/ParallaxTile';
import { SingleImage } from './SingleImage/SingleImage';

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const SteppedLayout: React.FC<IProps> = ({ animationReady, ...props }) => {
  const bodyContent: fromProjects.IContentSteppedLayoutSection = props.bodyContent as fromProjects.IContentSteppedLayoutSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
    rootMargin: "-150px 0 -150px 0",
  });

  const animateInSpring = useAnimateInSpring(inView);

  const getListComponents = useCallback(() => {
    const itemVariation: fromProjects.IContentSteppedLayoutVariations = bodyContent.variation;

    const listComponents = [];

    bodyContent.listItems.map((item, index) => {
      const listComponentCommonProps = {
        key: index,
        index,
        animationReady: inView,
      };

      if (itemVariation === 'singleImage') {
        const castItem: fromProjects.IContentSteppedLayoutSingleImage = item as fromProjects.IContentSteppedLayoutSingleImage;
        listComponents.push(<SingleImage {...listComponentCommonProps} item={castItem} />);
      } else if (itemVariation === 'parallaxTile') {
        const castItem: fromProjects.IContentSteppedLayoutParallaxTile = item as fromProjects.IContentSteppedLayoutParallaxTile;
        listComponents.push(<ParallaxTile {...listComponentCommonProps} item={castItem} />);
      }
    });

    return listComponents;
  }, [inView]);

  const steppedLayoutWrapperStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(x => `translateY(calc(${initialOffset(x)}))`),
  };

  const gridBackgroundStyles = {
    backgroundColor: bodyContent.backgroundColor,
    transform: animateInSpring.active.to(x => `translateX(calc(${initialOffset(x, -150)}))`),
  };

  return (
    <a.div
      ref={inViewRef}
      className={classNames(
        'steppedLayoutWrapper',
        bodyContent.variation,
      )}
      style={steppedLayoutWrapperStyles}
    >
      <a.div className='gridBackground' style={gridBackgroundStyles}>
        <LazyImage
          width='100%'
          height='100%'
          src={'/assets/images/work/' + bodyContent.backgroundImage.url}
          alt={bodyContent.backgroundImage.alt}
          animateImageIn={true}
          animationType={'fadeIn'}
        />
      </a.div>
      <div className='content-wrapper'>
        {getListComponents()}
      </div>
    </a.div>
  );
};

